import { ApiModule } from "@api/src/ApiModule"

// const isObject = (e) => typeof e === 'object' && !Array.isArray(e)
// const isObject = (e) => Object.prototype.toString.call(e).includes('Object')

export class Helpers extends ApiModule {
  // Testing a more advanced state mapper w/ getter and setter
  /**
   *
   * @param {*} storeName
   * @param {*} map
   *
   * @example
   * // i.e (storeName, { getter: mutator })
   * ...Ambition.Helpers.mapStateModel('summary', {
   *   assetType: 'saveAssetType',
   *   sellerType: 'saveSellerType',
   * }),
   *
   */
  mapStateModel(storeName, map) {
    const fns = {}
    Object.keys(map).forEach(e => {
      const mutator = map[e]

      fns[e] = {
        get() {
          return this.$store.getters[`${storeName}/${e}`]
        },
        set(v) {
          return this.$store.commit(`${storeName}/${mutator}`, v)
        }
      }
    })
    return fns
  }
  /**
   *
   * Map helper functions to Vue component
   *
   * @example
   * methods: {
   *   ...Ambition.Helpers.mapHelpers([
   *     'capitalise'
   *   ]),
   * }
   * @param {*} fns
   */
  mapHelpers(fns) {
    if (typeof fns === "string") fns = [fns]
    const map = {}
    fns.forEach(fn => (map[fn] = this[fn]))
    return map
  }

  capitalise(t) {
    return `${t.charAt(0).toUpperCase()}${t.slice(1)}`
  }

  titleCase(str) {
    str = str.toLowerCase().split(" ")
    for (var i = 0; i < str.length; i++) {
      str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1)
    }
    return str.join(" ")
  }

  appendVueData(context, keys) {
    const ob = {}
    keys.forEach(key => {
      const value = context[key]
      //
      //
      if (value) ob[key] = value
    })
    return ob
  }

  recursiveObjectSearch(object, key) {
    let result = []
    Object.values(object).forEach((e, i) => {
      const k = Object.keys(object)[i]
      // console.log(e[key])
      if (e[key]) result.push(e)
      else if (typeof e === "object")
        result = result.concat(this.recursiveObjectSearch(e, key))
    })
    return result
  }

  /**
   * Similar to Laravel helper
   *
   * @example
   * const a = { b: { c: { d: { name: 'It works!' } } } }
   * console.log(data_get(a, 'b.c.d.name'))
   *
   */
  data_get(obj, dot_notation_key, default_value = null) {
    try {
      const value = eval(`obj.${dot_notation_key}`)
      return typeof value === "string" ? value : default_value
    } catch (e) {}
    return default_value
  }

  truncateString(str, max) {
    if (!str) return str
    return str.length <= max ? str : str.slice(0, max) + "..."
  }

  timeout(ms = 3000) {
    return new Promise((resolve, reject) => setTimeout(resolve, ms))
  }
}
